<template>
    <div :class='["tbqr",{twoBox:!isOver}]' v-if='tbdw'>
        <template v-if='!isOver'>
            <div class="redBox">
                <p class='red' v-if='!isBegin'>确认未开始</p>
                <div v-else>
                    <p>确认剩余时间</p>
                    <myClock class='small lf' :shenyu='shenyu' :key='shenyu' cId='c1'></myClock>
                </div>
            </div>
            <div class="box">
                <table class='show'>
                    <colgroup width='160px'></colgroup>
                    <tr>
                        <td>投标单位</td>
                        <td>{{tbdw.fcqymc}}</td>
                    </tr>
                    <tr>
                        <td>确认时间</td>
                        <td><span v-html='qrsj'></span></td>
                    </tr>
                </table>
                <div class="btnBox" style='margin-top:40px'>
                    <el-button type="primary" @click="getKpdjgb" v-if='sfykpdjgb' :disabled='kpdjgbtbr'>显示开评定结果表</el-button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class='kbjs box'>
                <el-button type="primary rt" @click="getKpdjgb" style='margin-top:20px;margin-right:20px' v-if='sfykpdjgb' :disabled='kpdjgbtbr'>显示开评定结果表</el-button>
                <div class='jsy'>
                    <p>本次开标到此结束！</p>
                    <p>谢谢大家！</p>
                </div>
                <template v-if='!isHZ'>
                    <!-- <div class='ewm'>
                        <img src="../assets/images/ewm.png" alt="">
                        扫一扫关注"浙江招天下"
                    </div> -->
                    <div class='logo'></div>
                </template>
            </div>
        </template>
        <!-- 开评定弹窗 -->
        <el-dialog
        title="报表"
        :visible.sync="bbVisible"
        :close-on-click-modal="false"
        :fullscreen='true'
        >
            <div class='pdf'>
                <iframe :src="kpdjgbPdf" frameborder="0" width="100%" height="100%"></iframe>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="bbVisible=false">关闭</el-button>
                <el-button type="primary" @click="loadKpdjgb" :disabled="waitLoading">下载</el-button>
            </div>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>正在进行有效性审查，请耐心等待...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import setting  from "@/settings"
import myClock from '../components/clock/clock'
export default {
    name:'tbqr',
    props:['djlcId'],
    components:{
        myClock
    },
    data(){
        return{
            waitLoading:false,
            isBegin:false,//招标人是否开始确认
            shenyu:0,
            isSfqr:false,//投标人是否点击确认
            tbdw:'',
            qrsj:'',
            intervalTbqr:'',//定时器
            isOver:false,//主持人是否点击开标结束
            bbVisible:false,
            kpdjgbPdf:'',
            pdfId:'',
            sfykpdjgb:false,
            kpdjgbtbr:true
        }
    },
    computed:{
        isHZ(){
            return setting.stystemLx!=='ztx'?true:false
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId
            }
            this.$api.kbqrTbr(para).then(res=>{
                if(res.data.meta.success){
                    this.tbdw=res.data.data.tbdw;
                    this.isSfqr=res.data.data.tbdw.sfqr=="1"?true:false;
                    this.isOver=res.data.data.kbxm.zt=="2"?true:false
                    this.sfykpdjgb=res.data.data.sfykpdjgb;
                    this.kpdjgbtbr=res.data.data.kbxm.kpdjgbtbr==0?true:false;
                    if(res.data.data.kbxm.qrsj){
                        this.isBegin=true;
                        this.shenyu=res.data.data.sfszqrsj;
                        if(this.shenyu>=1000){
                            if(this.isSfqr){
                                this.qrsj=this.$moment(res.data.data.tbdw.qrsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qrsj='';
                                this.tbqrshenyuFun();
                            }
                        }else{
                            this.qrsj=res.data.data.tbdw.qrsj?this.$moment(res.data.data.tbdw.qrsj).format("YYYY-MM-DD HH:mm:ss"):'';
                        }
                    }else{
                        this.isBegin=false;
                        this.isSfqr=false;
                        this.qrsj=''
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //投标人点击确认按钮操作
        tbrDo(lx){
            if(lx=='tbqr'){
                this.$confirm('确认开标过程无误！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let para={}
                    let _this=this
                    this.$api.djqrTbr(para).then(res=>{
                        if(res.data.meta.success){
                            _this.$message({
                                type:'success',
                                message:'确认成功！'
                            })
                        }
                        clearInterval(_this.intervalTbqr);
                        _this.intervalTbqr=null;
                        let obj={
                            lx:'tb',
                            data:{
                                index:4,
                                msg:'2',
                                all:true
                            }
                        }
                        _this.$emit('send',JSON.stringify(obj))
                    }).catch(()=>{})
                }).catch(() => {});
            }
        },
        //计算剩余时间倒计时
        tbqrshenyuFun(){
            var _this=this;
            var time=this.shenyu
            var flag=false
            clearInterval(this.intervalTbqr);
            this.intervalTbqr=null;
            this.intervalTbqr=setInterval(function(){
                time=time-2000
                if(time<1000){
                    if(!flag){
                        flag=true
                        if(!_this.isOver){
                            let obj={
                                lx:'tb',
                                data:{
                                    index:4,
                                    msg:'2',
                                    all:false
                                }
                            }
                            _this.$emit('send',JSON.stringify(obj))
                        }else{
                            _this.getData();
                        }
                    }
                    clearInterval(_this.intervalTbqr);
                    _this.intervalTbqr=null;
                    return;
                }
            },2000)
        }, 
         //打开开评定结果弹窗
        getKpdjgb(){
            let para={}
            this.$api.getKpdjgb(para).then(res=>{
                if(res.data.meta.success){
                    this.kpdjgbPdf=res.data.data.pdfFile;
                    this.pdfId=res.data.data.id
                    this.bbVisible=true;
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        loadKpdjgb(){
            let para={
                id:this.pdfId
            }
            this.waitLoading=true
            this.$api.loadKpdjgb(para).then(res=>{
                let fileName = decodeURI(res.headers["content-disposition"].split("=")[1]);
                let blob = new Blob([res.data])
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName)
                } else {
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = fileName
                    link.click()
                    //释放内存
                    window.URL.revokeObjectURL(link.href)
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
    },
    mounted(){
        clearInterval(this.intervalTbqr);
        this.intervalTbqr=null;
        this.getData();
    },
    beforeDestroy(){
        clearInterval(this.intervalTbqr);
        this.intervalTbqr=null;
    }
}
</script>
<style lang="less">
.tbqr{
    .el-dialog__body{
        height:100%;
        .pdf{
            height:calc(~"100% - 60px");
            margin-bottom:10px;
        }

    }
}
</style>